<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-group form-row mx-1">
    <label [for]="idHtml">{{libelle$ | async }}</label>
    <div class="input-group">
      <div class="input-group-preprend" *ngIf="prefixe">
        <span class="input-group-text">{{prefixe}}</span>
      </div>
      <input type="text" [readOnly]="afficherEnLectureSeule" [placeholder]="placeholder" [maxlength]="longueurMax" [class.is-warning]="aErreurCroiseeActive()" [class.is-invalid]="champInvalide()"
        [class.is-valid]="champValide()" [formControlName]="label" class="form-control" [id]="idHtml">
    </div>
    <bis-affiche-erreurs *ngIf="erreursAffichable()" class="col-12" [erreurs]="rootForm.get(label).errors"></bis-affiche-erreurs>
  </div>
</form>